<app-app-holder>
    <app-navbar></app-navbar>

    <app-sidebar>
        <app-projects-subnav></app-projects-subnav>
    </app-sidebar>

    <app-content>
        <div *ngIf="work; else loading">
            <h2>{{ work.title }}</h2>
            <section class="m-b-3">
                <div class="sectiontitle sectiontitle--first">General information</div>
                <ul class="list__specs">
                    <li><label>Title</label> {{ work.title || '—' }}</li>
                    <li><label>Project type</label> {{ asTypeLabel(work.projectType) }}</li>
                    <li><label>Jira project key</label> {{ work.jiraProjectKey || '—' }}</li>
                    <li><label>Jira project ID</label> {{ work.jiraProjectId || '—' }}</li>
                    <li><label>Description</label> <span class="format-newlines">{{ work.description || '—' }}</span></li>
                    <li><label>PDF document</label> {{ getFileName(work.pdfUpload) }}</li>
                </ul>
            </section>

            <section class="m-b-3">
                <div class="sectiontitle">Dates & status</div>
                <ul class="list__specs">
                    <li><label>Start date</label> {{ work.startDate ? (work.startDate | date: 'yyyy-MM-dd') : '—' }}</li>
                    <li><label>End date</label> {{ work.endDate ? (work.endDate | date: 'yyyy-MM-dd') : '—' }}</li>
                    <li><label>Billable</label> {{ asYesNo(work.billable) }}</li>
                    <li><label>No end date</label> {{ asYesNo(work.present) }}</li>
                    <li><label>Warranty</label> {{ asYesNo(work.warranty) }}</li>
                    <li><label>Warranty start date</label> {{ work.warrantyStartDate ? (work.warrantyStartDate | date: 'yyyy-MM-dd') : '—' }}</li>
                    <li><label>Warranty end date</label> {{ work.warrantyEndDate ? (work.warrantyEndDate | date: 'yyyy-MM-dd') : '—' }}</li>
                    <li><label>Maintenance contract</label> {{ asYesNo(work.maintenanceContract) }}</li>
                    <li><label>Project finished</label> {{ asYesNo(work.finished) }}</li>
                </ul>
            </section>

            <section class="m-b-3">
                <div class="sectiontitle">Location</div>
                <ul class="list__specs" *ngIf="hasLocation(); else noLocation">
                    <li><label>Street</label> {{ work.location?.street || '—' }}</li>
                    <li><label>Number</label> {{ work.location?.number || '—' }}</li>
                    <li><label>Box</label> {{ work.location?.bus || '—' }}</li>
                    <li><label>Ext</label> {{ work.location?.ext || '—' }}</li>
                    <li><label>Zip code</label> {{ work.location?.postal || '—' }}</li>
                    <li><label>City</label> {{ work.location?.city || '—' }}</li>
                    <li><label>Country</label> {{ work.location?.country?.iso2 || '—' }}</li>
                </ul>
                <ng-template #noLocation>—</ng-template>
            </section>

            <section class="m-b-3">
                <div class="sectiontitle">Linked entities</div>
                <ul class="list__specs">
                    <li><label>Company</label> {{ work.partnerName || '—' }}</li>
                    <li><label>Customer</label> {{ fullName(work.customerFirstname, work.customerLastname) }}</li>
                    <li><label>Contact person</label> {{ fullName(work.contactPersonFirstname, work.contactPersonLastname) }}</li>
                    <li><label>Business developer</label> {{ fullName(work.businessDeveloperFirstname, work.businessDeveloperLastname) }}</li>
                    <li><label>Comanage contact ID</label> {{ work.comanageContactId || '—' }}</li>
                </ul>
            </section>

            <section class="m-b-3">
                <div class="sectiontitle">Invoicing</div>
                <ul class="list__specs">
                    <li><label>Budget (€)</label> {{ work.budget ?? '—' }}</li>
                    <li><label>Budget in man-days</label> {{ work.budgetInManDays ?? '—' }}</li>
                    <li><label>Invoice method</label> {{ asInvoiceMethodLabel(work.invoiceMethod) }}</li>
                    <li><label>Invoice per day</label> {{ asYesNo(work.invoiceByDay) }}</li>
                    <li><label>Hours per day</label> {{ work.hoursPerDay ?? '—' }}</li>
                    <li><label>PO number required</label> {{ asYesNo(work.poRequired) }}</li>
                    <li><label>Payment term (days)</label> {{ work.paymentTermDays ?? '—' }}</li>
                    <li><label>Invoice free text</label> <span class="format-newlines">{{ work.contractFreeText || '—' }}</span></li>
                </ul>
            </section>

            <section class="m-b-3">
                <div class="sectiontitle">Onderzoek en ontwikkeling</div>
                <ul class="list__specs">
                    <li><label>Komt in aanmerking</label> {{ asYesNo(work.researchDevelopmentEligible) }}</li>
                    <li><label>O&amp;O percentage</label> {{ work.researchDevelopmentEligible ? ((work.researchDevelopmentPercentage || 0) + '%') : '—' }}</li>
                </ul>
            </section>

            <section class="m-b-3">
                <div class="sectiontitle">Time registration</div>
                <ul class="list__specs">
                    <li><label>Time registration required</label> {{ asYesNo(work.timesheetRequired) }}</li>
                    <li><label>Registration type</label> {{ work.timesheetType || '—' }}</li>
                </ul>
            </section>
        </div>
    </app-content>

    <ng-template #loading>
        <app-loading-message></app-loading-message>
    </ng-template>
</app-app-holder>
